import React, { useContext } from "react";

import { ScrollNavMenuBlock as BaseScrollNavMenuBlock } from "@thelabnyc/thelabui/src/components/ScrollNavMenuBlock";

import { ReactivatedContext as Context } from "../../context";
import { ScrollNavMenuContainer } from "./ScrollNavMenuContainer";
import { ScrollNavMenuContainer2024 } from "./ScrollNavMenuContainer2024";

import styles2024 from "./index2024.module.scss";
import styles from "./index.module.scss";

export { ScrollNavMenuItemBlock } from "@thelabnyc/thelabui/src/components/ScrollNavMenuBlock";

interface Props
    extends React.ComponentPropsWithoutRef<typeof BaseScrollNavMenuBlock> {
    sku: string;
    title: string;
}

/**
 * Renders a sticky "table of contents" nav bar for navigating between sections
 * in the page. Items in the ToC are derived from whatever ScrollNavMenuItemBlock
 * components are also rendered on the page.
 */
export const ScrollNavMenuBlock = ({ title, sku, ...props }: Props) => {
    const isV2026 = useContext(Context).DESIGN_VERSION === "v2026";
    const itemStyles = isV2026 ? styles : styles2024;
    return (
        <BaseScrollNavMenuBlock
            {...props}
            classNames={{
                menuItem: itemStyles.menuItem,
                menuItemSelected: itemStyles.menuItemSelected,
            }}
            dependencies={{
                ScrollNavMenuContainer: (args) =>
                    isV2026 ? (
                        <ScrollNavMenuContainer {...args} />
                    ) : (
                        <ScrollNavMenuContainer2024
                            {...args}
                            title={title}
                            sku={sku}
                        />
                    ),
            }}
        />
    );
};
